module.exports = __webpack_public_path__ + "img/syncidle.b740b6b7.svg";